import { connect, useDispatch } from "react-redux";
import TechnologyResourceEdit from "./technologyResourceEdit";
import { useState, useEffect } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import {
  getTechnologyResources,
  getTechnologyResource,
  deleteTechnologyResource,
} from "../../../../../action/masters/technologyResourceActionCreator";
import { baseURL } from "../../../../../constants/commonConstants";
import {
  alertConstants,
  getAlertData,
} from "../../../../../helper/sweet-alert";
import {
  ITechnologyResourceIndex,
  ITechnologyResourceData,
} from "../../../../../models/master/technologyResource";
import { setTechnologyResources } from "../../../../../store/slices/master/technologyResourceSlice";
import TechnologyResourceCreate from "./technologyResourceCreate";
import ReactModal from "react-modal";
import LoaderSpinner from "../../../../../common-components/loader";

const TechnologyResourceIndex = (props: ITechnologyResourceIndex) => {
  const {
    getTechnologyResources,
    technologyResources,
    getTechnologyResource,
    technologyResource,
    deleteTechnologyResource,
  } = props;
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<number>(0);
  const [errors, setErrors] = useState<any>(undefined);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isEditLoading, setIsEditLoading] = useState<boolean>(false);
  const dispatch = useDispatch();

  const handleCreateOpen = () => setShowCreate(true);
  const handleCreateClose = () => setShowCreate(false);
  const handleEditOpen = () => setShowEdit(true);
  const handleEditClose = () => setShowEdit(false);

  const editItem = async (id: number) => {
    handleEditOpen();
    setIsEditLoading(true);
    try {
      await getTechnologyResource(id);
    } finally {
      setIsEditLoading(false);
    }
  };

  // executes when delete button is clicked
  const deleteItem = (id: number) => {
    setIsDelete(true);
    setAlert(alertConstants.inactiveCheck);
    setItemToDelete(id);
  };

  const onConfirm = () => {
    if (alertType === alertConstants.error) {
      setShowAlert(false);
    } else if (isDelete === true) {
      setShowAlert(false);
      setIsDelete(false);
      deleteTechnologyResource(itemToDelete, setAlert);
    } else {
      setShowAlert(false);
      setIsDelete(false);
      getTechnologyResources();
    }
  };

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  const getAllTechnologyResources = async () => {
    setIsLoading(true);
    try {
      await getTechnologyResources();
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getAllTechnologyResources();
    return () => {
      dispatch(setTechnologyResources([]));
    };
  }, []);

  return (
    <>
      <div className="admincontent">
        <div className="title">
          <h2>Technology Resources</h2>
          <a
            href="javascript:void(0)"
            className="btn btn-primary"
            data-bs-toggle="modal"
            data-bs-target="#addnewbuttons"
            onClick={handleCreateOpen}
          >
            <img src="/assets/images/icon/plus.svg" alt="" className="me-2" />
            Add New
          </a>
        </div>

        <ul className="d-flex gap-3 flex-wrap mt-28">
          {isLoading ? (
            <LoaderSpinner />
          ) : technologyResources && technologyResources.length > 0 ? (
            technologyResources.map(
              (technologyResource: ITechnologyResourceData) => {
                return (
                  <li
                    className="admin-card"
                    style={{
                      pointerEvents: !technologyResource.isActive
                        ? "none"
                        : "auto",
                      opacity: !technologyResource.isActive ? 0.5 : 1,
                    }}
                  >
                    <div className="top">
                      <div className="btn-flex">
                        <button
                          className="btn-edit"
                          onClick={() => editItem(technologyResource.id ?? 0)}
                        >
                          <img src="/assets/images/icon/edit-wh.svg" alt="" />
                        </button>
                        <button
                          className="btn-delete"
                          onClick={() => deleteItem(technologyResource.id ?? 0)}
                        >
                          <img src="/assets/images/icon/trash-wh.svg" alt="" />
                        </button>
                      </div>
                    </div>
                    <a href={technologyResource.url} target="_blank">
                      <div className="btm">
                        <div className="img">
                          <img
                            src={
                              technologyResource.image
                                ? baseURL + technologyResource.image
                                : ""
                            }
                          />
                        </div>
                        <h2>{technologyResource.resourceName}</h2>
                      </div>
                    </a>
                  </li>
                );
              }
            )
          ) : (
            <p>No Records Found</p>
          )}
        </ul>
      </div>

      <ReactModal
        isOpen={showCreate}
        onRequestClose={handleCreateClose}
        className="react-modal-content"
        overlayClassName="react-modal-overlay"
        shouldCloseOnOverlayClick={false}
      >
        <TechnologyResourceCreate
          setShowCreate={handleCreateClose}
          getAllTechnologyResources={() => getAllTechnologyResources()}
        />
      </ReactModal>
      {isEditLoading ? (
        <LoaderSpinner />
      ) : (
        <ReactModal
          isOpen={showEdit}
          onRequestClose={handleEditClose}
          className="react-modal-content"
          overlayClassName="react-modal-overlay"
          shouldCloseOnOverlayClick={false}
        >
          <TechnologyResourceEdit
            setShowEdit={handleEditClose}
            getAllTechnologyResources={() => getAllTechnologyResources()}
            technologyResource={technologyResource}
          />
        </ReactModal>
      )}

      <SweetAlert
        show={showAlert}
        success={false}
        type={alertType}
        title={alertTitle}
        onConfirm={() => onConfirm()}
        showCancel={isDelete}
        onCancel={() => {
          setShowAlert(false);
          setIsDelete(false);
        }}
        cancelBtnText={"No"}
        confirmBtnText={isDelete ? "Yes" : "Ok"}
      />
    </>
  );
};

const mapDispatchToProps = {
  getTechnologyResources: () => getTechnologyResources(),
  getTechnologyResource: (id: number) => getTechnologyResource(id),
  deleteTechnologyResource: (id: number, callBack: Function) =>
    deleteTechnologyResource(id, callBack),
};

function mapStateToProps(state: any) {
  return {
    technologyResources: state.technologyResource.technologyResources,
    technologyResource: state.technologyResource.technologyResource,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TechnologyResourceIndex);
